import StatCard from '@/app/(home)/components/stat-card';
import FullWidthSection from '@/components/full-width-section';
import { formatPeopleCount } from '@/lib/utils';
import { useLatestStatistic } from '@/services/query/statistics.query';

const StatsSection = () => {
  const { data: statisticEntity } = useLatestStatistic();

  const stats = [
    {
      label: '누적가입수🎯',
      value: formatPeopleCount(
        statisticEntity?.data?.cumulativeSignups ?? 80000,
      ),
    },
    {
      label: '합격률📈',
      value:
        statisticEntity?.data?.passRate !== undefined &&
        statisticEntity?.data?.passRate !== null
          ? statisticEntity.data.passRate.toFixed(2) + '%'
          : '95%',
    },
    {
      label: '평균 연습🗓️',
      value:
        statisticEntity?.data?.averagePracticeTime !== undefined &&
        statisticEntity?.data?.averagePracticeTime !== null
          ? statisticEntity.data.averagePracticeTime + '시간'
          : '14시간',
    },
  ];
  return (
    <FullWidthSection className="from-level-1/87 via-bg-[#383838] to-level-1 bg-gradient-to-b">
      <div className="desktop:flex desktop:justify-center">
        <div className="desktop:web-w desktop:w-full desktop:relative">
          <div className="bg-white-rhombus-pattern transform2 desktop:h-14 desktop:right-0 desktop:w-[302px] absolute top-0 right-3 h-7.5 w-40.5"></div>
          <section className="desktop:pb-15 relative flex h-auto justify-center overflow-visible pt-12.5 pb-10">
            <div
              aria-hidden
              className="desktop:h-[266px] desktop:w-[979px] desktop:top-20 absolute top-7.5 left-10 aspect-[367/100] w-[72%]"
              style={{
                backgroundImage:
                  "url('/images/main/drivingzone_watermark.svg')",
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
              }}
            />

            <div className="desktop:pt-[114px] relative w-full px-6 pt-8 text-center">
              <h2 className="typo-32 desktop:typo-50 font-black">
                <span className="text-main-yellow">드라이빙존</span>{' '}
                <span className="text-white">운전면허?</span>
              </h2>
              <p className="font-regular typo-18 desktop:hidden pt-6 leading-relaxed break-words text-[#dbdbdb]">
                전문 운전강사와 함께 안전한{' '}
                <span className="font-bold text-white">
                  실내에서 운전면허 취득을 준비하는 실내운전연습장입니다.
                </span>{' '}
                운전시뮬레이터를 통해 운전면허시험장 코스를 무한반복
                연습함으로서{' '}
                <span className="font-bold text-white">
                  가장 안전하고 빠른 운전면허 취득을 지원합니다.
                </span>
              </p>
              <p className="desktop:block font-regular typo-18 desktop:typo-24 desktop:leading-[48px] desktop:pt-11 hidden pt-6 leading-relaxed break-words text-[#dbdbdb]">
                전문 운전강사와 함께 안전한{' '}
                <span className="font-bold text-white">
                  실내에서 운전면허 취득을 준비하는 실내운전연습장입니다.
                </span>
                <br />
                운전시뮬레이터를 통해 운전면허시험장 코스를 무한반복
                연습함으로서{' '}
                <span className="font-bold text-white">
                  가장 안전하고 빠른 운전면허 취득을 지원합니다.
                </span>
              </p>

              <div className="desktop:mt-15 desktop:gap-8 mt-10 flex flex-row flex-wrap items-center justify-center gap-[7px]">
                {stats.map((stat, key) => (
                  <StatCard key={key} label={stat.label} value={stat.value} />
                ))}
              </div>
              <span className="typo-14 desktop:typo-15 desktop:text-level-5 desktop:leading-snug inline-block w-full pt-6 text-center leading-snug font-medium text-[#707070]">
                {/**모바일 */}
                <span className="desktop:hidden">
                  * 합격률은 합격 무제한반 기준입니다. <br />
                  * 상기 수치는 드라이빙존 내부 집계 기준에 따른 산출
                  <br />
                  수치이며, 일정 조건 하에서의 계산된 값입니다.
                </span>
                {/**웹 */}
                <span className="desktop:block hidden">
                  * 상기 수치는 드라이빙존 내부 집계 기준에 따른 산출 수치이며,
                  일정 조건 하에서의 계산된 값입니다.
                </span>
              </span>
            </div>
            <div className="desktop:inline-block text-level-5 typo-15 absolute bottom-30.5 hidden font-semibold">
              * 합격 무제한반 기준
            </div>
          </section>
        </div>
      </div>
    </FullWidthSection>
  );
};

export default StatsSection;
